
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("ivYev", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});

parcelRegister("c9Gut", function(module, exports) {
'use strict';
var $8d97490175e0a0ad$var$undefined1;

var $5Xb5B = parcelRequire("5Xb5B");

var $idMoS = parcelRequire("idMoS");

var $2YFZL = parcelRequire("2YFZL");

var $cqAmg = parcelRequire("cqAmg");

var $etKfU = parcelRequire("etKfU");

var $D1lVv = parcelRequire("D1lVv");

var $bVAoT = parcelRequire("bVAoT");

var $d3V6K = parcelRequire("d3V6K");

var $lXcnW = parcelRequire("lXcnW");

var $iua2G = parcelRequire("iua2G");

var $ceH9r = parcelRequire("ceH9r");

var $iuE8N = parcelRequire("iuE8N");

var $lFL8t = parcelRequire("lFL8t");

var $dGDcJ = parcelRequire("dGDcJ");

var $j2xjE = parcelRequire("j2xjE");
var $8d97490175e0a0ad$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $8d97490175e0a0ad$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $8d97490175e0a0ad$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $9B7nE = parcelRequire("9B7nE");

var $f4Yps = parcelRequire("f4Yps");
var $8d97490175e0a0ad$var$throwTypeError = function() {
    throw new $bVAoT();
};
var $8d97490175e0a0ad$var$ThrowTypeError = $9B7nE ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $8d97490175e0a0ad$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $9B7nE(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $8d97490175e0a0ad$var$throwTypeError;
        }
    }
}() : $8d97490175e0a0ad$var$throwTypeError;

var $8d97490175e0a0ad$var$hasSymbols = (parcelRequire("gDar2"))();

var $m9GUf = parcelRequire("m9GUf");

var $hCZzY = parcelRequire("hCZzY");

var $cP63e = parcelRequire("cP63e");

var $9t9l6 = parcelRequire("9t9l6");

var $gZa5S = parcelRequire("gZa5S");
var $8d97490175e0a0ad$var$needsEval = {};
var $8d97490175e0a0ad$var$TypedArray = typeof Uint8Array === 'undefined' || !$m9GUf ? undefined : $m9GUf(Uint8Array);
var $8d97490175e0a0ad$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $8d97490175e0a0ad$var$hasSymbols && $m9GUf ? $m9GUf([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $8d97490175e0a0ad$var$needsEval,
    '%AsyncGenerator%': $8d97490175e0a0ad$var$needsEval,
    '%AsyncGeneratorFunction%': $8d97490175e0a0ad$var$needsEval,
    '%AsyncIteratorPrototype%': $8d97490175e0a0ad$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $idMoS,
    '%eval%': eval,
    '%EvalError%': $2YFZL,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $8d97490175e0a0ad$var$$Function,
    '%GeneratorFunction%': $8d97490175e0a0ad$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $8d97490175e0a0ad$var$hasSymbols && $m9GUf ? $m9GUf($m9GUf([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$8d97490175e0a0ad$var$hasSymbols || !$m9GUf ? undefined : $m9GUf(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $5Xb5B,
    '%Object.getOwnPropertyDescriptor%': $9B7nE,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $cqAmg,
    '%ReferenceError%': $etKfU,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$8d97490175e0a0ad$var$hasSymbols || !$m9GUf ? undefined : $m9GUf(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $8d97490175e0a0ad$var$hasSymbols && $m9GUf ? $m9GUf(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $8d97490175e0a0ad$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $D1lVv,
    '%ThrowTypeError%': $8d97490175e0a0ad$var$ThrowTypeError,
    '%TypedArray%': $8d97490175e0a0ad$var$TypedArray,
    '%TypeError%': $bVAoT,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $d3V6K,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $gZa5S,
    '%Function.prototype.apply%': $9t9l6,
    '%Object.defineProperty%': $f4Yps,
    '%Object.getPrototypeOf%': $hCZzY,
    '%Math.abs%': $lXcnW,
    '%Math.floor%': $iua2G,
    '%Math.max%': $ceH9r,
    '%Math.min%': $iuE8N,
    '%Math.pow%': $lFL8t,
    '%Math.round%': $dGDcJ,
    '%Math.sign%': $j2xjE,
    '%Reflect.getPrototypeOf%': $cP63e
};
if ($m9GUf) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $8d97490175e0a0ad$var$errorProto = $m9GUf($m9GUf(e));
    $8d97490175e0a0ad$var$INTRINSICS['%Error.prototype%'] = $8d97490175e0a0ad$var$errorProto;
}
var $8d97490175e0a0ad$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $8d97490175e0a0ad$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $8d97490175e0a0ad$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $8d97490175e0a0ad$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $m9GUf) value = $m9GUf(gen.prototype);
    }
    $8d97490175e0a0ad$var$INTRINSICS[name] = value;
    return value;
};
var $8d97490175e0a0ad$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $lssto = parcelRequire("lssto");

var $beYMl = parcelRequire("beYMl");
var $8d97490175e0a0ad$var$$concat = $lssto.call($gZa5S, Array.prototype.concat);
var $8d97490175e0a0ad$var$$spliceApply = $lssto.call($9t9l6, Array.prototype.splice);
var $8d97490175e0a0ad$var$$replace = $lssto.call($gZa5S, String.prototype.replace);
var $8d97490175e0a0ad$var$$strSlice = $lssto.call($gZa5S, String.prototype.slice);
var $8d97490175e0a0ad$var$$exec = $lssto.call($gZa5S, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $8d97490175e0a0ad$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $8d97490175e0a0ad$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $8d97490175e0a0ad$var$stringToPath = function stringToPath(string) {
    var first = $8d97490175e0a0ad$var$$strSlice(string, 0, 1);
    var last = $8d97490175e0a0ad$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $D1lVv('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $D1lVv('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $8d97490175e0a0ad$var$$replace(string, $8d97490175e0a0ad$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $8d97490175e0a0ad$var$$replace(subString, $8d97490175e0a0ad$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $8d97490175e0a0ad$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($beYMl($8d97490175e0a0ad$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $8d97490175e0a0ad$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($beYMl($8d97490175e0a0ad$var$INTRINSICS, intrinsicName)) {
        var value = $8d97490175e0a0ad$var$INTRINSICS[intrinsicName];
        if (value === $8d97490175e0a0ad$var$needsEval) value = $8d97490175e0a0ad$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $bVAoT('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $D1lVv('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $bVAoT('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $bVAoT('"allowMissing" argument must be a boolean');
    if ($8d97490175e0a0ad$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $D1lVv('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $8d97490175e0a0ad$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $8d97490175e0a0ad$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $8d97490175e0a0ad$var$$spliceApply(parts, $8d97490175e0a0ad$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $8d97490175e0a0ad$var$$strSlice(part, 0, 1);
        var last = $8d97490175e0a0ad$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $D1lVv('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($beYMl($8d97490175e0a0ad$var$INTRINSICS, intrinsicRealName)) value = $8d97490175e0a0ad$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bVAoT('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($9B7nE && i + 1 >= parts.length) {
                var desc = $9B7nE(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $beYMl(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $8d97490175e0a0ad$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5Xb5B", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("idMoS", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("2YFZL", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("cqAmg", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("etKfU", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("D1lVv", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("bVAoT", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("d3V6K", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("lXcnW", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iua2G", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("ceH9r", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("iuE8N", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("lFL8t", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("dGDcJ", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("j2xjE", function(module, exports) {
'use strict';

var $4MGvr = parcelRequire("4MGvr");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4MGvr(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4MGvr", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("9B7nE", function(module, exports) {
'use strict';

var $691lB = parcelRequire("691lB");
var $6fcd4b5ad405c154$require$$gOPD = $691lB;
if ($6fcd4b5ad405c154$require$$gOPD) try {
    $6fcd4b5ad405c154$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $6fcd4b5ad405c154$require$$gOPD = null;
}
module.exports = $6fcd4b5ad405c154$require$$gOPD;

});
parcelRegister("691lB", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("f4Yps", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $afa616d8d6b8b05a$var$$defineProperty = Object.defineProperty || false;
if ($afa616d8d6b8b05a$var$$defineProperty) try {
    $afa616d8d6b8b05a$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $afa616d8d6b8b05a$var$$defineProperty = false;
}
module.exports = $afa616d8d6b8b05a$var$$defineProperty;

});

parcelRegister("gDar2", function(module, exports) {
'use strict';
var $c1b862094b2c130b$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $ivYev = parcelRequire("ivYev");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $c1b862094b2c130b$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $c1b862094b2c130b$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $ivYev();
};

});

parcelRegister("m9GUf", function(module, exports) {
'use strict';

var $cP63e = parcelRequire("cP63e");

var $hCZzY = parcelRequire("hCZzY");

var $lM7mr = parcelRequire("lM7mr");
/** @type {import('.')} */ module.exports = $cP63e ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $cP63e(O);
} : $hCZzY ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $hCZzY(O);
} : $lM7mr ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lM7mr(O);
} : null;

});
parcelRegister("cP63e", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("hCZzY", function(module, exports) {
'use strict';

var $5Xb5B = parcelRequire("5Xb5B");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $5Xb5B.getPrototypeOf || null;

});

parcelRegister("lM7mr", function(module, exports) {
'use strict';

var $f8At8 = parcelRequire("f8At8");

var $9B7nE = parcelRequire("9B7nE");
var $0417497548df67e5$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $0417497548df67e5$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $0417497548df67e5$var$desc = !!$0417497548df67e5$var$hasProtoAccessor && $9B7nE && $9B7nE(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $0417497548df67e5$var$$Object = Object;
var $0417497548df67e5$var$$getPrototypeOf = $0417497548df67e5$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $0417497548df67e5$var$desc && typeof $0417497548df67e5$var$desc.get === 'function' ? $f8At8([
    $0417497548df67e5$var$desc.get
]) : typeof $0417497548df67e5$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $0417497548df67e5$var$$getPrototypeOf(value == null ? value : $0417497548df67e5$var$$Object(value));
} : false;

});
parcelRegister("f8At8", function(module, exports) {
'use strict';

var $lssto = parcelRequire("lssto");

var $bVAoT = parcelRequire("bVAoT");

var $gZa5S = parcelRequire("gZa5S");

var $lTOpV = parcelRequire("lTOpV");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $bVAoT('a function is required');
    return $lTOpV($lssto, $gZa5S, args);
};

});
parcelRegister("lssto", function(module, exports) {
'use strict';

var $js8G8 = parcelRequire("js8G8");
module.exports = Function.prototype.bind || $js8G8;

});
parcelRegister("js8G8", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $e2975d3e2002958c$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $e2975d3e2002958c$var$toStr = Object.prototype.toString;
var $e2975d3e2002958c$var$max = Math.max;
var $e2975d3e2002958c$var$funcType = '[object Function]';
var $e2975d3e2002958c$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $e2975d3e2002958c$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $e2975d3e2002958c$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $e2975d3e2002958c$var$toStr.apply(target) !== $e2975d3e2002958c$var$funcType) throw new TypeError($e2975d3e2002958c$var$ERROR_MESSAGE + target);
    var args = $e2975d3e2002958c$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $e2975d3e2002958c$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $e2975d3e2002958c$var$concatty(args, arguments));
    };
    var boundLength = $e2975d3e2002958c$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $e2975d3e2002958c$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("gZa5S", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("lTOpV", function(module, exports) {
'use strict';

var $lssto = parcelRequire("lssto");

var $9t9l6 = parcelRequire("9t9l6");

var $gZa5S = parcelRequire("gZa5S");

var $85OZa = parcelRequire("85OZa");
/** @type {import('./actualApply')} */ module.exports = $85OZa || $lssto.call($gZa5S, $9t9l6);

});
parcelRegister("9t9l6", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("85OZa", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("beYMl", function(module, exports) {
'use strict';
var $82f025e3176d692c$var$call = Function.prototype.call;
var $82f025e3176d692c$var$$hasOwn = Object.prototype.hasOwnProperty;

var $lssto = parcelRequire("lssto");
/** @type {import('.')} */ module.exports = $lssto.call($82f025e3176d692c$var$call, $82f025e3176d692c$var$$hasOwn);

});


parcelRegister("kdnt5", function(module, exports) {
'use strict';

var $c9Gut = parcelRequire("c9Gut");

var $f8At8 = parcelRequire("f8At8");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $eb7739d18cce400d$var$$indexOf = $f8At8([
    $c9Gut('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $c9Gut(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $eb7739d18cce400d$var$$indexOf(name, '.prototype.') > -1) return $f8At8(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


//# sourceMappingURL=shared.33b6f45c.js.map
